import Vue from "vue"
import VueIdle from "idle-vue"
import { TOKEN_REFRESH_IDLE_TIME } from "@/config/constants"

const eventsHub = new Vue()

Vue.use(VueIdle, { idleTime: TOKEN_REFRESH_IDLE_TIME, eventEmitter: eventsHub })
